export default __webpack_public_path__ + "static/media/head8.a08f7bbb.svg";